import React from "react";

/**
 * Logo — official Syllox brand mark. Single source of truth for the
 * in-app brand logo (the small dark-green square with the S inside a
 * circle, sparkle, and open book that you see in the navbar, footer,
 * login page, and landing hero).
 *
 * The asset lives at /public/syllox-logo.png (256×256, ~50 KB), so it
 * benefits from the CDN/static cache the rest of /public uses and stays
 * outside the JS bundle. PWA icons (favicon, apple-touch, manifest) all
 * derive from the same 1254×1254 master.
 *
 * Why an <img> not lucide Sparkles?
 *   Before Jun 2026 every brand spot rendered a tinted square containing a
 *   lucide <Sparkles> icon. That was a placeholder. Now we render the real
 *   logo, which is self-contained (it brings its own dark background +
 *   green accent), so callers no longer need the green wrapper div.
 *
 * Caller migration:
 *   Before: <div className="grid h-9 w-9 place-items-center rounded-xl bg-emerald-500 text-white shadow"><Sparkles size={18}/></div>
 *   After:  <Logo className="h-9 w-9" />
 *
 * The className prop controls size + shape — defaults preserve the
 * 9×9 + rounded-xl convention used pre-migration.
 */
export default function Logo({ className = "h-9 w-9", alt = "Syllox" }) {
  return (
    <img
      src="/syllox-logo.png"
      alt={alt}
      width={256}
      height={256}
      decoding="async"
      loading="eager"
      className={`${className} rounded-xl object-cover`}
      data-testid="syllox-logo"
    />
  );
}
